import React, { useEffect, useState } from 'react';
import { Card, Form, Modal } from 'react-bootstrap';
import { salvaOpzioniScheda } from '../../../../api-client/appPlayer';
import AnteprimaScheda from './AnteprimaScheda';

/*
 * La scheda della struttura nell'app SportID Player (sportid-docs, interventi del 7-8/10/2026, sez. B, D, E):
 * lo stile (uguale per chi la guarda) e se mostrare il numero dei soci. Foto e video stanno nella tab «Foto e video».
 * Stile e soci si salvano appena si scelgono.
 */

const STILI = [
    { valore: 1, nome: 'Copertina', descrizione: 'Foto grande a tutta larghezza in alto' },
    { valore: 2, nome: 'Galleria e numeri', descrizione: 'Foto grande e due piccole, con il video' },
    { valore: 3, nome: 'Sobria', descrizione: 'Solo testo e informazioni, poche immagini' },
];

export const FormSchedaApp = ({ profile, disabilitato = false }) => {
    const club = profile?.club;
    const [stile, setStile] = useState(1);
    const [soci, setSoci] = useState(true);
    const [errore, setErrore] = useState('');
    const [salvato, setSalvato] = useState(false);

    useEffect(() => {
        if (!club) return;
        setStile(club.pageTemplate || 1);
        setSoci(club.showMembers !== false);
    }, [club]);
    useEffect(() => {
        if (!salvato) return undefined;
        const t = setTimeout(() => setSalvato(false), 2500);
        return () => clearTimeout(t);
    }, [salvato]);

    const salva = async (modifiche, annulla) => {
        const r = await salvaOpzioniScheda(modifiche);
        if (r?.error) { annulla?.(); setErrore(r.error); return false; }
        setSalvato(true);
        return true;
    };

    const scegliStile = (valore) => {
        if (disabilitato || valore === stile) return;
        const prima = stile;
        setStile(valore);
        salva({ pageTemplate: valore }, () => setStile(prima));
    };

    const cambiaSoci = (valore) => {
        setSoci(valore);
        salva({ showMembers: valore }, () => setSoci(!valore));
    };

    if (!club) return null;

    return (
        <>
            <Modal show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Errore durante l'operazione</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>
            <Card>
                <Card.Body className="sid-card-body--spaced">
                    <h5 className="sid-form-section">Stile della scheda</h5>
                    <p className="sid-nota-leggibile">Come appare la scheda della struttura a chi la apre nell'app (nell'anteprima, dati di esempio).</p>
                    <div className="sid-stili-scheda" role="radiogroup" aria-label="Stile della scheda">
                        {STILI.map((s) => (
                            <button
                                type="button"
                                role="radio"
                                aria-checked={stile === s.valore}
                                key={s.valore}
                                className={`sid-stile-scheda ${stile === s.valore ? 'is-scelto' : ''}`}
                                onClick={() => scegliStile(s.valore)}
                                disabled={disabilitato}
                            >
                                <AnteprimaScheda stile={s.valore} soci={soci} />
                                <strong>{s.valore} · {s.nome}</strong>
                                <span>{s.descrizione}</span>
                            </button>
                        ))}
                    </div>

                    <h5 className="sid-form-section">Numero dei soci</h5>
                    <Form.Check
                        type="switch"
                        id="mostra-soci"
                        label="Mostra il numero dei soci nella scheda"
                        checked={soci}
                        disabled={disabilitato}
                        onChange={(e) => cambiaSoci(e.target.checked)}
                    />
                </Card.Body>
            </Card>
            {salvato && <div className="sid-avviso-salvato" role="status">✓ Modifica salvata</div>}
        </>
    );
};

export default FormSchedaApp;
